export const iconFontAwesomeUsersPeoplePersonWalking = (
	<i className="fa-solid fa-person-walking"></i>
);
